import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { EncuestaPendiente } from 'src/app/servicios/encuesta-satisfaccion/encuesta-satisfaccion.service';

@Component({
  selector: 'app-invitacion-encuesta-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './invitacion-encuesta-dialog.component.html',
  styleUrls: ['./invitacion-encuesta-dialog.component.scss'],
})
export class InvitacionEncuestaDialogComponent {
  readonly data = inject<EncuestaPendiente>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<InvitacionEncuestaDialogComponent>);

  responderAhora() {
    this.dialogRef.close('responder');
  }

  masTarde() {
    this.dialogRef.close('mas_tarde');
  }
}
